import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, DialogTrigger, Dialog, Button, ModalOverlay } from 'react-aria-components';
import ReactPlayer from 'react-player';

function VideoModal({ children, title, video }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
            <Button onClick={() => setIsOpen(true)}>{children}</Button>
            <ModalOverlay isDismissable>
                <Modal>
                    <Dialog>
                        <button
                            className="modal-close-button"
                            type="button"
                            aria-label={t('Tancar')}
                            onClick={() => setIsOpen(false)}
                        >
                            <svg width="34" height="34" xmlns="http://www.w3.org/2000/svg">
                                <g strokeWidth="3" stroke="#fff" fill="none" fillRule="evenodd">
                                    <path d="m2 2 30 30M32 2 2 32" />
                                </g>
                            </svg>
                        </button>
                        <div className="modal-player">
                            <ReactPlayer
                                src={video}
                                playing={isOpen}
                                controls
                                width="100%"
                                height="100%"
                            />
                        </div>
                        {title && <p className="modal-caption">{title}</p>}
                    </Dialog>
                </Modal>
            </ModalOverlay>
        </DialogTrigger>
    );
}

export default VideoModal;
